// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1245":"fb28e4ac","2949":"c2d2168c","5400":"74bf38ba"}[chunkId] + ".chunk.css";
};